<script lang="ts">
import { AttachmentType } from '@smartsupp/smartsupp-message'
import { getContext } from 'svelte'

import { testIds } from '@/constants'
import { PreviewedMediaType } from '@/modules/app'
import { previewedMedia } from '@/modules/app/mediaPreview'
import { contentMessageAttachmentKey, type WritableMessageAttachmentContext } from '@/modules/messages'

let context = $derived(getContext<WritableMessageAttachmentContext>(contentMessageAttachmentKey))
let {
	neighbors,
	messageContext: { group },
	attachment,
} = $derived($context)
let { align } = $derived(group)

const getImageUrl = (): string => {
	if (!attachment || attachment.type !== AttachmentType.Image) return ''
	return attachment.thumb400?.url || attachment.url
}

const showImagePreview = () => {
	attachment.type === AttachmentType.Image && previewedMedia.set({ attachment, type: PreviewedMediaType.Image })
}

const imageLoaded = (e: Event) => {
	const img = e.target as HTMLImageElement
	img.removeAttribute('width')
	img.removeAttribute('height')
	img.classList.remove('bg-slate-200')
}
</script>

{#if attachment && attachment.type === AttachmentType.Image}
	<div
		role="button"
		tabindex="0"
		class={['cursor-pointer max-w-[80%]', align.isRight && 'float-right']}
		onclick={showImagePreview}
		onkeydown={() => {}}
		onkeyup={() => {}}
		data-testid={testIds.messageImage}
	>
		<img
			src={getImageUrl()}
			alt={attachment.fileName}
			width={attachment.width}
			height={attachment.height}
			class={[
				'min-h-[16px] min-w-[16px] max-h-[240px] bg-slate-200',
				align.isLeft && 'rounded-r-3xl',
				align.isRight && 'rounded-l-3xl',
				align.isLeft && !neighbors.hasTop && 'rounded-lt-3xl',
				align.isLeft && !neighbors.hasBottom && 'rounded-lb-3xl',
				align.isRight && !neighbors.hasTop && 'rounded-rt-3xl',
				align.isRight && !neighbors.hasBottom && 'rounded-rb-3xl',
			]}
			onload={imageLoaded}
		/>
	</div>
{/if}
